import { Component, Prop } from "vue-property-decorator";
import SelectForm from "../../SelectForm";
import { InputOption, KeyValue } from "../../../../../../models/Input";

@Component
export default class CiviliteSelectForm extends SelectForm {
	@Prop()
	public dataInputOption!: InputOption;

	public keyValue: KeyValue[] = [
		{
			key: "M.",
			value: "M."
		},
		{
			key: "MME",
			value: "Mme"
		},
		{
			key: "MLE",
			value: "Mle"
		}
	];

	public changed(): void {
		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/SelectForm/selects/CiviliteSelectForm/CiviliteSelectForm.ts